/**
 * @desc 根据爬虫请求ID终止爬虫任务
 */
const URL = "/rantion-crawler";
import http, { updateResponse } from "@/http";
export function request(id: string | number, options?: any) {
  return updateResponse(
    http(URL + `/crawler/terminate/${id}`, {
      method: "POST",

      ...options,
    }),
  );
}
